const ESP_CUSTOM = {
  accessToWifi: 'Disponer de acceso Wi-Fi en el lugar de carga.',
  AFTER_10PM_BEFORE_11AM: 'Después de las 22:00; antes de las 11:00.',
  AFTER_11AM_BEFORE_10PM: 'Después de las 11:00; antes de las 22:00.',
  AFTER_1230AM_BEFORE_930AM:
    'Después de las 12:30 a. m.; antes de las 9:30 a. m.',
  AFTER_12PM_BEFORE_8PM:
    'Después de las 12 del mediodía; antes de las 8 de la tarde.',
  AFTER_2PM_BEFORE_6PM: 'Después de las 14:00; antes de las 18:00',
  AFTER_6AM_BEFORE_3PM:
    'Después de las 6 de la mañana; antes de las 3 de la tarde.',
  AFTER_6PM_BEFORE_9AM: 'Después de las 18:00; antes de las 9:00.',
  AFTER_8AM_BEFORE_MN: 'Después de las 8 de la mañana; antes de la medianoche.',
  AFTER_9PM_BEFORE_6AM: 'Después de las 9 p. m.; antes de las 6 a. m.',
  AFTER_9PM_BEFORE_9AM: 'Después de las 9 p. m.; antes de las 9 a. m.',
  AFTER_MN_BEFORE_8AM: 'Después de medianoche; antes de las 8 de la mañana',
  'after.Incentives': 'DESPUÉS DE LOS INCENTIVOS',
  agreeOffPeakSchedule: 'Acordar cobrar en horario de menor demanda.',
  ALL_HOURS: 'Todas las horas (impredecibles)',
  ATTACHED_GARAGE: 'Garaje adjunto',
  averageMonthlyCharge: 'PROMEDIO MENSUAL DE CARGA',
  averageMonthlyCharge_tool:
    'Seleccione el monto total de los cargos eléctricos (sin incluir los cargos de gas) en una factura mensual típica, independientemente de la temporada. Usamos esta cantidad para estimar una base de referencia para su consumo de energía actual.',
  basement: 'Sótano',
  basicFilters: 'Filtros Básicos',
  certifiedElectrician: 'Electricista Certificado',
  charger: 'CARGADOR',
  chargeWithLevelTwoCharger:
    'Cárguelo con un cargador de nivel 2 compatible o conduzca un vehículo eléctrico compatible.',
  'chargingMap.disclaimer':
    'Datos proporcionados por el Centro de Datos de Combustibles Alternativos. El mapa puede no reflejar la disponibilidad más reciente de estaciones de carga.',
  'chargingMap.updateZipcode': 'Actualizar código postal',
  'chargingStations.mapLegend.high': 'Centrales de alta potencia',
  'chargingStations.mapLegend.highSubtext':
    'Carga rápida de CC o supercargadores',
  'chargingStations.mapLegend.other': 'Otros tipos de estaciones',
  'chargingStations.mapLegend.private': 'Estaciones privadas',
  'chargingStations.mapLegend.public': 'Estaciones públicas',
  'chargingStations.mapLegend.publicSubtext':
    'Instalado por empresas o gobiernos.',
  close: 'Cerca',
  'compareVehicles.carMake': 'Marca de auto',
  'compareVehicles.carModel': 'Modelo de auto',
  'compareVehicles.fuelType': 'Tipo de combustible',
  'compareVehicles.subTitle':
    'Seleccione al menos dos vehículos para comenzar la comparación.',
  contact: 'Contacto',
  ContactInformation: 'Información del contacto',
  conventionalVehicleEfficiency:
    'EFICIENCIA DE LOS VEHÍCULOS CONVENCIONALES (MPG)',
  conventionalVehicleEfficiencyTooltip:
    'Para calcular posibles ahorros, ingrese las millas por galón (MPG) del vehículo de gasolina que desea reemplazar con un EV totalmente eléctrico o híbrido enchufable.',
  costOfPublicCharging: 'COSTO DEL COBRO PÚBLICO',
  costOfPublicChargingTooltip:
    'Estimamos el costo de las estaciones de carga públicas pagas, pero puede editar este filtro si conoce el costo de carga local.',
  CountiesCovered: 'Condados cubiertos',
  currency: '$',
  currentPricingPlan: 'PLAN DE PRECIOS ACTUAL',
  DETACHED_GARAGE: 'Garaje independiente',
  driveEVOrPHEV:
    'Conducir un vehículo eléctrico (totalmente eléctrico o híbrido enchufable)',
  DRIVEWAY: 'No en un garaje',
  DRParagraph1:
    'El plan de precios estándar de DR se basa en la cantidad de electricidad que usa, no cuando la usa. Cuanta menos electricidad use, menos pagará, a cualquier hora, de día o de noche.',
  DRParagraph2:
    'Este plan puede ser una buena opción para los hogares de bajo uso y aquellos que prefieren ahorrar conservando sin pensar en la hora del día.',
  egbBringCharger: 'Usaré mi propio cargador de nivel 2.',
  egbNeedCharger: 'Necesito un cargador de nivel 2',
  egbOurPrograms:
    'Contamos con programas que facilitan la carga en casa. Si necesita un cargador de nivel 2, nuestro programa EV Accelerate At Home podría ser ideal para usted.',
  'electricians.fastEfficient':
    '{title} Nuestros plazos de instalación están garantizados y se agilizan para ayudarle a empezar a trabajar cuanto antes.',
  'electricians.industrial': 'Industrial',
  'electricians.map.caption':
    '¿Es usted un electricista instalador de estaciones de subministro de combustible VE certificado? Por favor contacte {email} para ser considerado en nuestra base de datos de electricistas certificados. Los electricistas en la lista de esta página web no son avalados ni empleados por SDG&E.',
  'electricians.map.header': 'Beneficios de nuestros socios preferidos',
  'electricians.map.personalizedExperience':
    '{title} Nuestros especialistas en vehículos eléctricos pueden guiarle a través de todo el proceso.',
  'electricians.map.value':
    '{title} Ofrecemos precios de instalación competitivos.',
  'electricians.subtitle':
    'Para buscar un electricista certificado en su área ingrese su código postal. Haga clic en cada uno de los resultados para ver la información y contacto.',
  'electricians.title': 'Electricistas Certificados',
  'electricians.worldClass':
    '{title} Nos asociamos con electricistas experimentados que han sido verificados para garantizar una instalación segura y profesional.',
  electricity: 'Costo de electricidad',
  electricPortion: 'PARTE ELÉCTRICA',
  'Energy Information Administration':
    'Administración de Información Energética',
  estimatedDIYCost: 'Coste medio estimado para hacerlo usted mismo:',
  'ev.avg.range': 'Alcance eléctrico promedio',
  'ev.carDetails.calc.charging': 'Carga',
  'ev.carDetails.calc.chargingRate': 'Tarifa de cobro',
  'ev.carDetails.calc.DCFC': 'Velocidad de carga rápida de CC (DCFC)',
  'ev.cardetails.calc.description': 'Descripción',
  'ev.carDetails.calc.description': 'Descripción',
  'ev.cardetails.calc.electricEmissionsLbsMwhMetric':
    'Emisiones eléctricas en kg/MWh',
  'ev.cardetails.calc.electricEmissionsMetric': 'Emisiones eléctricas en kg',
  'ev.cardetails.calc.electricityEmissionsMetric':
    'Emisiones de electricidad en kg de CO2/MWh',
  'ev.carDetails.calc.electricityEmissionsMetric':
    'Emisiones de electricidad en kg de CO2/MWh',
  'ev.carDetails.calc.emissions': 'Emisiones',
  'ev.cardetails.calc.emissionsReductions': 'Reducción de emisiones',
  'ev.cardetails.calc.EPAMetric': 'Calificación de eficiencia del NRC',
  'ev.carDetails.calc.ev.cardetails.calc.electricityEmissions':
    'Emisiones de electricidad en libras de CO2/MWh',
  'ev.carDetails.calc.fuel': 'Combustible',
  'ev.cardetails.calc.FuelConsumptionCa':
    'Guía de consumo de combustible de Canadá',
  'ev.cardetails.calc.gasolineEmissionskg': 'Emisiones de gasolina en kg',
  'ev.cardetails.calc.gasolineEmissionsMetric':
    'Emisiones de gasolina en kg por litro',
  'ev.cardetails.calc.gasolineEmissionsYrMetric':
    'Emisiones de gasolina en kg de CO2/año',
  'ev.cardetails.calc.kgCo2PerYr': 'kg de CO2 por año',
  'ev.cardetails.calc.kmDrivenPerYr': 'Kilómetros recorridos por año',
  'ev.carDetails.calc.kmDrivenPerYr': 'Kilómetros recorridos por año',
  'ev.carDetails.calc.kwPerKm': 'kWh por 100 km',
  'ev.carDetails.calc.kwPerMile': 'kWh por cada 100 millas',
  'ev.cardetails.calc.litersSaved': 'Litros ahorrados',
  'ev.cardetails.calc.litersSavedFormula':
    'Litros utilizados por un vehículo de gasolina equivalente - Litros utilizados por un vehículo eléctrico',
  'ev.cardetails.calc.litersUsed': 'Litros utilizados',
  'ev.cardetails.calc.litersUsedFormula':
    'Kilómetros recorridos * (1 - Parte de conducción eléctrica) * L/100 km',
  'ev.cardetails.calc.lPer100Km': 'L/100 km',
  'ev.cardetails.calc.lPerKm': 'Litros por cada 100 kilómetros',
  'ev.cardetails.calc.lpkm': 'litros/kilómetro',
  'ev.carDetails.calc.milesDriven': 'Millas recorridas por año',
  'ev.carDetails.calc.milesPerGallonBasic': 'Millas por galón',
  'ev.cardetails.calc.nationalAverageElectricityEmissions':
    'Emisiones medias nacionales de electricidad',
  'ev.cardetails.calc.source': 'Fuente',
  'ev.carDetails.calc.source': 'Fuente',
  'ev.cardetails.electricRange':
    'Para tener en cuenta la degradación de la batería, la autonomía que se indica aquí es una estimación basada en la antigüedad del vehículo y los patrones normales de conducción y carga.',
  'ev.carDetails.kilometerBatterySizeTooltip':
    'Un kilovatio-hora (kWh) proporciona energía suficiente para recorrer entre 1 y 4 millas, dependiendo del vehículo. La batería de un portátil típico tiene una capacidad inferior a 0,1 kWh.',
  'ev.carDetails.kilometerUsedBatterySizeTooltip':
    'Un kilovatio-hora (kWh) proporciona energía suficiente para recorrer entre 1 y 4 kilómetros, según el vehículo. Para tener en cuenta la degradación de la batería en un vehículo eléctrico usado, la capacidad de la batería que se indica aquí es una estimación basada en la antigüedad del vehículo y los patrones normales de conducción y carga.',
  'ev.carDetails.mobile':
    'Para obtener más detalles, incluidos los gráficos de cálculos de {amp}, consulte esta página en un ordenador de escritorio.',
  'ev.carDetails.usedBatterySizeTooltip':
    'Un kilovatio-hora (kWh) proporciona energía suficiente para recorrer entre 1 y 4 millas, según el vehículo. Para tener en cuenta la degradación de la batería en un vehículo eléctrico usado, la capacidad de la batería que se indica aquí es una estimación basada en la antigüedad del vehículo y los patrones normales de conducción y carga.',
  'ev.carDetails.view': 'Ver detalles del vehículo',
  'ev.chargingStations.body':
    'Cargar tu dispositivo sobre la marcha es más fácil que nunca. Introduce tu ubicación para ver todas las estaciones de carga cercanas.',
  'ev.costOfPublicCharing': 'Coste estimado de la carga pública',
  'ev.dealers.body':
    'Descubre los concesionarios de vehículos eléctricos de tu zona y haz clic en cada uno para ver su ubicación e información de contacto.',
  'ev.electricityRateCalc':
    'La tarifa eléctrica se calcula como una tarifa combinada basada en un consumo doméstico promedio de 700 kWh. Para obtener más información, haga clic en {website}.',
  'ev.electricPortionTooltip':
    'Seleccione el monto total de los cargos eléctricos (sin incluir los cargos de gas) en una factura mensual típica, independientemente de la temporada. Usamos esta cantidad para estimar una base de referencia para su consumo de energía actual.',
  'ev.incentives.title.simple': 'Incentivos y descuentos disponibles',
  'ev.jumbotron.findADealer': 'Encuentra un distribuidor',
  'ev.kilometersDrivenAnnually': 'Kilómetros recorridos por año',
  'ev.matchScore.adjustment': 'Ajuste',
  'ev.matchScore.budget': 'Presupuesto',
  'ev.matchScore.charging': 'Carga',
  'ev.matchScore.maxScore': 'Puntuación máxima',
  'ev.matchScore.popover':
    'Tu puntuación de coincidencia se basa en las preferencias que hayas seleccionado.',
  'ev.matchScore.range': 'Rango',
  'ev.matchScore.seats': 'Asientos',
  'ev.matchScore.title': 'Resultado del partido',
  'ev.matchScore.totalScore': 'Puntuación total',
  'ev.matchScore.yourScore': 'Tu puntuación',
  'ev.planningRoute.body':
    'Cargar tu vehículo eléctrico sobre la marcha es más fácil que nunca. Introduce tu destino para ver todas las estaciones de carga disponibles en el camino.',
  'ev.public': 'Público',
  'ev.publicPrivateCharging': 'Combinación de cobros públicos y privados',
  'ev.showSources.blendedMaintenanceCostPerKilometer':
    'Coste de mantenimiento combinado por kilómetro',
  'ev.showSources.blendedMaintenanceCostPerKilometerSource':
    'Porcentaje de conducción eléctrica destinado al mantenimiento por kilómetro para gasolina y para electricidad.',
  'ev.showSources.dollarPerKilometerDriven': '$/100 km recorridos',
  'ev.showSources.dollarPerKilometerDrivenPublicCharging':
    '(Costo estimado de la carga pública * Carga mixta pública/privada + Tarifa de electricidad * (1 - Carga mixta pública/privada)) * kWh del vehículo por 100 km',
  'ev.showSources.dollarPerKilometerDrivenSource':
    'Coste de la electricidad * kWh del vehículo por cada 100 km',
  'ev.showSources.dollarPerMileDrivenPublicCharging':
    '(Costo estimado de carga pública * Carga mixta pública/privada + Tarifa de electricidad * (1 - Carga mixta pública/privada)) * kWh del vehículo por cada 100 millas',
  'ev.showSources.estimatedCostOfPublicCharging':
    'Costo estimado de la carga pública',
  'ev.showSources.insuranceSource': 'Costo promedio del seguro en',
  'ev.showSources.kilometerVehicleKWh': 'kWh del vehículo por cada 100 km',
  'ev.showSources.lifetimeKilometers': 'Kilómetros de por vida',
  'ev.showSources.maintenanceCostReductionSource': '{website}',
  'ev.showSources.maintenancePerKilometer':
    'Mantenimiento por kilómetro para gasolina',
  'ev.showSources.maintenancePerKilometerElectricity':
    'Mantenimiento por kilómetro para electricidad',
  'ev.showSources.maintenancePerKilometerElectricitySource':
    'Mantenimiento por kilómetro para gasolina * Factor de reducción de mantenimiento de vehículos eléctricos',
  'ev.showSources.mixPublicPrivateCharging': 'Cobro mixto público/privado',
  'ev.showSources.portionElectricSourceKilometer':
    'Entrada de datos del usuario. Para un vehículo híbrido, estima la proporción de kilómetros recorridos utilizando la batería eléctrica en lugar de gasolina.',
  'ev.showSources.totalKilometerElectricityCostSource':
    '$/100 km recorridos * Kilómetros totales * {portionEVDriving}/ 100',
  'ev.showSources.totalKilometerGasolineCostSource':
    'Costo de la gasolina * Kilómetros de por vida * {portionEVDriving}/ lPorKm',
  'ev.showSources.totalKilometerMaintenanceCostSource':
    'Coste de mantenimiento por kilómetro * Kilómetros de vida útil',
  'ev.showSources.vehiclelPerKm':
    'Consumo de combustible del vehículo (litros por kilómetro)',
  'ev.used.electricRange': 'Alcance eléctrico promedio',
  'eventCard.hostedBy': 'Organizado por',
  'eventCard.inPerson': 'Evento presencial',
  'eventCard.inPersonAndVirtual': 'Evento presencial y virtual',
  'eventCard.learnMore': 'Más información',
  'eventCard.virtualEvent': 'Evento virtual',
  'eventCatalog.noEvents':
    'No se han encontrado eventos que coincidan con sus criterios de búsqueda actuales. Intente cambiar sus criterios de búsqueda.',
  'eventCatalog.noMatch': 'No encontramos ninguna coincidencia.',
  events: 'Eventos',
  'events.allLocations': 'Todas las ubicaciones',
  'events.autoshow': 'Salón del automóvil',
  'events.both': 'En persona y virtual',
  'events.conference': 'Conferencia',
  'events.distance': 'Distancia',
  'events.educationEvent': 'Evento educativo',
  'events.inPerson': 'En persona',
  'events.inPersonOrVirtual': 'En persona o virtualmente',
  'events.nationwide': 'A escala nacional',
  'events.nationWide': 'A escala nacional',
  'events.rideAndDrive': 'Viaje y conducción',
  'events.subHeader':
    'Podrá ver, tocar y sentir un vehículo eléctrico en persona en un próximo evento.',
  'events.training': 'Capacitación',
  'events.virtual': 'Virtual',
  'events.webinar': 'Seminario web',
  eventsDateRange: 'Rango de fechas',
  eventsFilters: 'Filtros',
  'eventSort.dateLtH': 'Fecha (La más próxima primero)',
  'evfilter.carTitle': 'Preferencia de VE',
  'evs.chargercard.chargingtime.na': 'N / A',
  'evs.chargerCatalog.noChargers': 'No se encontraron cargadores',
  'evs.graph.compare':
    'Compara coches eléctricos por autonomía o precio. Pasa el cursor sobre el coche para obtener más detalles.',
  'evs.graph.disclaimer':
    'Los vehículos mostrados pueden no reflejar la disponibilidad real. {companyName} no respalda ni recomienda ningún vehículo ni fabricante de automóviles en particular.',
  'evs.graph.mobile':
    'Para ver el gráfico de alcance frente a coste, consulte esta página en un ordenador de sobremesa.',
  'evs.graph.rangeVsCost': 'Alcance vs. Costo',
  'evs.graph.tiles': 'Baldosas de vehículos',
  'evs.graph.title': 'Vehículos eléctricos',
  'evs.highPower.legend': 'Centrales de alta potencia',
  'evs.incentivesScoreOptions': 'Filtros de elegibilidad de incentivos',
  'evs.other.legend': 'Otros tipos de estaciones',
  'evs.public.legend': 'Estaciones públicas',
  'evs.welcomeSubMobile':
    'Adapta tu búsqueda para descubrir vehículos eléctricos que se ajusten a tus necesidades.',
  FAQ: 'Preguntas frecuentes',
  feet: 'pies',
  filing_status_tooltip:
    'Se utiliza para determinar la elegibilidad para incentivos.',
  fuel_tooltip:
    'Seleccione todos los tipos de carrocería de vehículos que le interesen.',
  Finished: 'Finalizado',
  'footer.chargingStations': '{chargingStations}',
  'footer.compareVehicles': '{compareVehicles}',
  'footer.copyright':
    '© 1998-2026 San Diego Gas & Electric Company. Las marcas comerciales aquí utilizadas son propiedad de sus respectivos dueños. Todos los derechos reservados.',
  'footer.disclaimer':
    '{COMPANY_NAME}® es una filial de Sempra®. SDG&E® y San Diego Gas & Electric son marcas registradas de San Diego Gas & Electric Company.',
  'footer.electricVehicles': '{electricVehicles}',
  'footer.homeChargers': '{homeChargers}',
  'footer.incentives': '{incentives}',
  'footer.jdpDisclaimer':
    'Las cifras mostradas en esta página son estimaciones basadas en datos proporcionados por terceros. Este material se proporciona únicamente con fines informativos y no debe considerarse asesoramiento fiscal, legal o financiero. Ni J.D. Power® ni SDG&E brindan asesoramiento fiscal, legal o financiero. Debe verificar de forma independiente las estimaciones proporcionadas aquí antes de realizar cualquier transacción.',
  'footer.zappyDisclaimer':
    'Las cifras que aparecen en esta página son estimaciones basadas en datos proporcionados por terceros. Este material se ofrece únicamente con fines informativos y no debe considerarse asesoramiento fiscal, legal ni financiero. Ni J.D. Power® ni SDGE ofrecen asesoramiento fiscal, legal ni financiero. Le recomendamos que verifique de forma independiente las estimaciones aquí presentadas antes de realizar cualquier transacción.',
  'footer.zappyDisclaimer.one':
    'Soluciones para vehículos eléctricos © 2026 J.D. Power, proporcionado con autorización.',
  footerPhrase1: 'Tarifas y Reglamentos',
  footerPhrase10: 'Tarifas Eléctricas Totales',
  footerPhrase11: 'Elección del cliente',
  footerPhrase2: 'Solicitud de datos de energía',
  footerPhrase3: 'Términos y condiciones',
  footerPhrase4: 'Normas de Conducta de la FERC - Orden 717',
  footerPhrase5: 'Proyectos mayores',
  footerPhrase6: 'Servicio al Cliente',
  footerPhrase7: 'Publicaciones de la CPUC',
  footerPhrase8: 'Carreras',
  footerPhrase9: 'Centro de privacidad',
  forInstallation: 'para instalación',
  forLevelTwoCharger: 'para cargador de nivel 2',
  forSeparateMeter: 'para medidor independiente',
  free: 'Gratis',
  ft: 'pie',
  galperyear: 'gal/año',
  garage: 'Cochera',
  gasolinePrice: 'PRECIO DE LA GASOLINA',
  gasolinePriceInCentsPerGal_tooltip:
    'Ingrese el precio local de la gasolina. Nuestro valor predeterminado se basa en el precio de gasolina más reciente de su región, actualizado mensualmente.',
  'graph.costDifferent': '¿Por qué el precio es diferente?',
  'graph.costOfOwnership.totalRow': 'Total',
  'graph.costVsRange.afterIncentives':
    'Desde {price} después de los incentivos',
  'graph.costVsRange.electricKilometerRange':
    'Autonomía eléctrica: {kilometers} kilómetros',
  'graph.costVsRange.electricRange': 'Autonomía eléctrica: {miles} millas',
  'graph.electricRange.assumptions': 'Supuestos',
  'graph.electricRange.description': 'Descripción',
  'graph.electricRange.electricity': 'Electricidad',
  'graph.electricRange.gasoline': 'Gasolina',
  'graph.electricRange.total': 'Total',
  'graph.fuelRange.chart.chargedHome': 'cargado en casa',
  'graph.fuelRange.chart.description': 'Descripción',
  'graph.fuelRange.chart.fuelBudget': 'presupuesto de combustible',
  'graph.fuelRange.chart.howFar':
    '¿Qué distancia puedes recorrer con el {car} con un presupuesto de combustible de {budget}?',
  'graph.fuelRange.chart.kilometers': 'kilómetros',
  'graph.fuelRange.chart.miles': 'millas',
  'graph.fuelRange.chart.network': 'en la red Plug-In Everywhere',
  'graph.fuelRange.chart.rangeOn': 'Rango en',
  'graph.fuelRange.chart.similarGas': 'un vehículo de gas similar',
  'graph.fuelRange.chart.unlimited': 'Ilimitado',
  'graph.showCostBreakdown': 'Mostrar desglose de costos',
  'graph.speedOfCharge.kilometersLevelTwoChargerThreeCars':
    'Se cargan los kilómetros por hora más rápido con un cargador de nivel 2.',
  'graph.speedOfCharge.kilometersThirtyFastChargeThreeCars':
    'Carga la mayor cantidad de kilómetros por cada 30 minutos de carga rápida.',
  'graph.speedOfCharge.kmLevelTwoCharger':
    'kilómetros por hora con un cargador de nivel 2',
  'graph.speedOfCharge.kmThirtyFastCharge':
    'kilómetros por cada 30 minutos de carga rápida',
  'graph.title.miles': 'Millas',
  'graph.title.totalRange': 'Rango total',
  hcaCarCondition: 'ESTADO DEL COCHE',
  hcaCarMake: 'Marca del coche',
  hcaCarModel: 'Modelo de coche',
  hcaChargerLocation: 'Ubicación del cargador',
  hcaCurrentElectricRate: 'Tarifa eléctrica actual',
  hcaCurrentMonthlyBill: 'Factura mensual actual',
  hcaDistanceSliderLabel: 'Distancia: Desde el panel hasta el punto de carga.',
  hcaDistanceSliderLabelToolTip:
    'Tenga en cuenta que los circuitos eléctricos no suelen discurrir en línea recta entre el panel y el punto de carga debido a las paredes, los suelos o el espacio exterior que se interponen.',
  hcaElectricPanelLocation: 'Ubicación del panel eléctrico',
  hcaIncludedEnergyCosts: 'COSTOS DE ENERGÍA INCLUIDOS',
  hcaNewestModels: 'Modelos más recientes',
  hcaOlderModels: 'Modelos antiguos',
  hcaPanelLocationRoomType: 'Ubicación del panel Tipo de habitación',
  hcaPortionPublicCharging: 'Parte de la zona de cobro público',
  hcaPortionPublicChargingTooltip:
    'Los conductores de vehículos eléctricos realizan casi toda la carga en casa.',
  hcaPublicChargingCost: 'Costo de carga pública',
  hcaWhenWillYouCharge: '¿Cuándo cobrarás?',
  'header.cards.electricians': 'Encuentre un electricista certificado',
  'header.cards.home-chargers': 'Compre cargadores domésticos',
  'header.cards.incentives': 'Buscar incentivos',
  'header.cards.rates': 'Ver la calculadora de ahorros',
  'header.chargingStations': 'Estaciones de carga',
  'header.compareVehicles': 'Comparar vehículos',
  'header.electricians': 'Electricistas',
  'header.electricVehicles': 'Vehículos Eléctricos',
  'header.home': 'Inicio',
  'header.homeChargers': 'Cargadores domésticos',
  'header.incentives': 'Incentivos',
  'header.promise.cta': 'Inicie aquí con incentivos',
  'header.promise.subtitle':
    'Calcule y compare los costos, ahorros, incentivos y más de los VE.',
  'header.promise.title': 'Saque el máximo provecho a su VE.',
  'header.rates': 'Calculadora de ahorros',
  high: 'Alto',
  home: 'Hogar',
  'home.vehicleCarousel.browseAllEvs': 'Explorar todos VEs',
  'home.vehicleCarousel.compareEvs': 'Comparar VEs',
  'home.vehicleCarouselSubTitle':
    'Compare su selección con un vehículo a gasolina similar. Un vehículo eléctrico puede ahorrarle dinero porque puede ser más económico de poseer y mantener que un automóvil 100% propulsado por gasolina.',
  'home.vehicleCarouselTitle':
    'Hay más vehículos eléctricos que nunca. Descubre el tuyo.',
  homechargerChargerType: 'TIPO DE CARGADOR',
  homechargerEvfilter: 'Filtros Básicos',
  'homechargers.caption':
    'Los cargadores VE en la lista de esta pagina web no son manufacturados o avalados por SDG&E.',
  'homeChargers.disclaimer':
    'Fabricantes de cargadores, ¿desean que su cargador aparezca aquí? Póngase en contacto con {email}.',
  'homeChargers.meterCable': 'Cable {length} m',
  'homeChargers.selectMake': 'Marca',
  'homeChargers.selectModel': 'Modelo',
  'homeChargers.subtitle':
    'Encuentra opciones de cargadores VE nivel 2 adecuados para tu hogar y VE. Ajusta los filtros y personaliza tus resultados.',
  'homeChargers.title': 'Cargadores domésticos',
  'homepage.linkCard.findDealers': 'Encuentra distribuidores de {lineBreak}',
  'homepage.welcome': 'Colton recargado',
  'homepage.zipcode.disclaimer':
    'Planes de precios personalizados en menos de 1 minuto. No es necesario registrarse.',
  'homepage.zipcode.getStarted': 'Empezar',
  'homepage.zipcode.subtitle':
    'Esta herramienta identificará claramente el plan de precios de vehículos eléctricos de menor costo.',
  'homepage.zipcode.title':
    '¿Sabías que ofrecemos una variedad de planes de precios eléctricos? Encuentre el mejor plan de precios de vehículos eléctricos para usted',
  homeWiring: 'CABLEADO DOMÉSTICO',
  household_income_tooltip:
    'Combine los ingresos de todos los miembros del hogar. Se utiliza para determinar la elegibilidad para incentivos.',
  household_size_tooltip:
    'Se utiliza para determinar la elegibilidad para incentivos. Incluya a todos los miembros de su hogar (cónyuge, dependientes, etc.). Pocos o ningún incentivo mencionan hogares de más de 8 miembros, así que seleccione 8 si el tamaño de su hogar es de 8 o más.',
  'incentives.electricityProvider': 'Proveedor de electricidad',
  'incentives.householdIncomeTooltip':
    'Combine los ingresos de todos los miembros del hogar. Se utiliza para determinar la elegibilidad para incentivos.',
  'incentives.householdSizeTooltip':
    'Incluya a todos los miembros de su hogar (cónyuge, desodorantes, etc.). Se utiliza para determinar la elegibilidad para los incentivos.',
  'incentives.retiringVehicleTooltip':
    'Para acceder a ciertos incentivos, puede ser necesario dar de baja un vehículo de gasolina antiguo.',
  'incentives.selectModel': 'Seleccionar modelo',
  'incentives.selectTrim': 'Seleccione Recortar',
  'incentives.taxFilingStatusTooltip':
    'Se utiliza para determinar la elegibilidad para los incentivos.',
  'incentiveSort.aToZ': 'Alfabético: de la A a la Z',
  'incentiveSort.largest': 'Primero el más grande',
  'incentiveSort.zToA': 'Alfabético: Z a A',
  'input-zipcode-for-rate-comp-launch':
    'Se utiliza para determinar la elegibilidad para los incentivos. Incluya a todos los miembros de su hogar (cónyuge, dependientes, etc.). Pocos incentivos, o ninguno, mencionan hogares de más de 8 miembros, así que seleccione 8 si su hogar tiene 8 o más integrantes.',
  install: 'INSTALAR',
  kgperyear: 'kg/año',
  kilometersShort: 'kilómetros',
  lbsperyear: 'libras/año',
  linkUnavailable: 'Enlace a la red no disponible',
  literperyear: 'L/año',
  liveInResidenceState:
    'Residir en una vivienda que recibe servicio eléctrico de Xcel Energy en {stateName}',
  loading: 'Cargando',
  low: 'Bajo',
  m: 'metro',
  maps: 'Mapas',
  'matchScore.adjustment': 'Ajuste',
  'matchScore.budget': 'Presupuesto',
  'matchScore.charging': 'Carga',
  'matchScore.maxScore': 'Puntuación máxima',
  'matchScore.popover':
    'Tu puntuación de coincidencia se basa en las preferencias que hayas seleccionado.',
  'matchScore.range': 'Rango',
  'matchScore.seats': 'Asientos',
  'matchScore.title': 'Resultado del partido',
  'matchScore.totalScore': 'Puntuación total',
  'matchScore.yourScore': 'Tu puntuación',
  medium: 'Medio',
  'miles-driven-annually-range_tooltip':
    'Según las estimaciones del Departamento de Transporte sobre el promedio de millas anuales recorridas en 2020, un conductor típico registra alrededor de 16,000 millas por año.',
  milesDrivenAnnually_tooltip:
    'Según las estimaciones del Departamento de Transporte sobre el promedio de millas anuales recorridas en 2020, un conductor típico registra alrededor de 16,000 millas por año.',
  modal1: 'Cual es el promedio del costo de carga de su VE por mes?',
  modal10: 'Un conductor maneja un promedio de 12,000 millas al año.',
  modal11: '¿A qué hora del día prefiere cargar su VE?',
  modal12:
    'Recomendación: Cargar tu VE durante las horas de la noche (entre 12-6 a.m.) es más económico. Puedes programar tu VE para que se recargue durante la noche o a la hora más adecuada para ti.',
  modal13: 'Todas horas',
  modal14: '¿Cuál es tu plan de tarifa actual?',
  modal15: 'Consejo: La mayoría de los clientes tienen la tarifa TOU-DR1.',
  modal16:
    'Nota: Para los clientes con planes de precios que no son VE (incluidos DR, TOU-DR1 y DR-SES), asumimos que actualmente conduce un vehículo de gasolina con un tipo, marca y precio similares al VE seleccionado en el Paso 2 y mostramos los ahorros al cambiar a este VE. Para los clientes en el plan de precios EV-TOU-5, asumimos que ya posee el VE seleccionado y mostramos sus ahorros actuales en relación con los planes de precios que no son VE.',
  modal2: 'Paso',
  modal3: 'de',
  modal4: 'Siguiente',
  modal5: 'Cual VE posees o cual quiere comprar/rentar?',
  modal6: 'Sugerencia: Puedes ajustar los filtros después del resultado.',
  modal7:
    'Elija su EV actual o preferido para ver ahorros potenciales en diferentes planes de precios. La selección del vehículo afecta los ahorros potenciales en la factura eléctrica debido a las diferencias en el rendimiento eléctrico y la eficiencia entre los modelos.',
  modal8: 'Previo',
  modal9: '¿En promedio, cuantas millas maneja su auto al año?',
  'model.year': 'Año del modelo',
  month: 'mes',
  monthWord: 'Mes',
  new: 'Nuevo',
  no: 'No',
  overTenYears: 'MÁS DE 10 AÑOS',
  pages: 'Páginas',
  portionOfPublicCharging: 'PARTE DEL COBRO PÚBLICO',
  portionOfPublicChargingTooltip:
    'Si no puedes cargar en casa, tendrás que hacerlo en estaciones de carga públicas de pago. Calcule qué porcentaje del tiempo de carga de los vehículos eléctricos se realizaría en estaciones de carga públicas de pago en lugar de en casa.',
  'pre-owned': 'Usado',
  Preferredpartner: 'Socio Preferido',
  prefferedEvChargingTimeframe: 'CALENDARIO PREFERIDO DE RECARGA DE VE',
  prefferedEvChargingTimeframe_tooltip:
    'Cargar por la noche (de 12 a 6 a.m.) es más rentable. Puedes programar tu vehículo eléctrico para que se cargue durante el horario que más te convenga.',
  prefferedEvMake: 'MARCA DE VE PREFERIDA',
  prefferedEvMake_tooltip:
    'Nota: Suponemos que actualmente conduce un automóvil de gasolina de tipo, marca y precio similar al del vehículo eléctrico elegido.',
  prefferedEvModel: 'MODELO DE VE PREFERIDO',
  'rateAdvisor.caption':
    'Esta calculadora de ahorros se proporciona con fines ilustrativos. No es una promesa ni garantía de que sus costos de carga reales sean iguales a los costos que se muestran en la herramienta. SDG&E no garantiza la exactitud, integridad o utilidad de la información de costos estimados. SDG&E renuncia expresamente a la responsabilidad por los daños y perjuicios de cualquier naturaleza que surjan en relación con el uso de la herramienta Calculadora de Ahorros. Sus costos de carga reales variarán en función de una serie de factores. “SDG&E” se refiere a San Diego Gas & Electric Company. ©2022 SDG&E. Reservados todos los derechos.',
  'rateAdvisor.pricingPlanComparison': 'Comparación de planes de precios',
  'rateAdvisor.sub':
    'Identifica tus oportunidades de ahorro con un VE. Ajusta los filtros para ver tus ahorros.',
  'rateAdvisor.title': 'Calculadora de Ahorros',
  'rateComparisoin.youAreAlreadySaving':
    'Ya estás ahorrando hasta {highlightText} si tienes un EV y usa la {highlight} plan tarifario.',
  'rateComparison.youAreAlreadySaving':
    'Ya estás ahorrando hasta {highlightText} si tienes un vehículo eléctrico y utilizas el plan tarifario {highlight}.',
  'rateComparison.youAreAlreadySavingVehicle':
    'Ya estás ahorrando hasta {highlightText} por año en {highlight} con un {selectedVehicle}.',
  'rateComparison.youAreSaving':
    'Estás ahorrando hasta {highlightText} si tienes un EV y usa la {highlight} plan tarifario.',
  'rateComparison.youAreSavingVehicle':
    'Puede ahorrar {highlightText} por año en {highlight} con un {selectedVehicle}.',
  rateDRSESParagraph1:
    'DR-SES es el plan para clientes de energía solar y otras energías renovables. El precio se basa en la hora y el día de la semana, junto con la cantidad de electricidad que usa. Ganará créditos en la factura enviando su exceso de energía a la red de energía.',
  rateDRSESParagraph2:
    'Este plan podría ser una buena opción para usted si genera energía renovable, si puede cambiar sus actividades de uso de energía a antes de las 4 p.m. y después de las 9 p.m., y si puede aprovechar la electricidad de menor precio durante las horas de menor actividad.',
  rateEVTOU5Paragraph1:
    'El plan EV-TOU-5 es para que los clientes carguen vehículos eléctricos en casa. El precio se basa en la cantidad de electricidad que usa y cuándo, con tres períodos de precios. A cambio de una tarifa de servicio básico, ofrecemos nuestras tarifas más bajas para la carga nocturna de vehículos eléctricos en casa.',
  rateEVTOU5Paragraph2:
    'Este plan podría ser una buena opción si puede cambiar parte de su consumo de electricidad lejos de las horas pico de 4 a 9 p.m. y puede cargar regularmente un vehículo eléctrico durante el período súper fuera de pico a altas horas de la noche.',
  rateTOUDR1Paragraph1:
    'El precio de TOU-DR1 se basa en la cantidad de electricidad que usa, así como la hora y el día de la semana en que la usa. Con tres períodos de precios, existe la oportunidad de ahorrar más en noches y fines de semana.',
  rateTOUDR1Paragraph2:
    'Este plan podría ser una buena opción si puede cambiar parte de su consumo de electricidad lejos de las horas pico de 4 a 9 p.m. y puede aprovechar la electricidad de menor precio durante las horas de menor actividad durante las noches y los fines de semana.',
  regularResidential: 'Residencial regular',
  'results.updated': 'Los resultados se han actualizado a partir de',
  saved: 'ahorro',
  'select-charger-level_tooltip':
    'Más vehículos eléctricos le resultarán convenientes si puede cargar rápidamente en casa.',
  savingsGraphDisclaimer:
    '* Supone que alimenta su hogar con este plan de precios y actualmente maneja un vehículo a gasolina con un tipo, marca y precio similar al VE que seleccionó.',
  savingsGraphEVLabel: 'Vehículo eléctrico',
  savingsGraphGasLabel: 'Vehículo de gasolina',
  savingsGraphHomeLabel: 'Uso Electrico de Hogar',
  savingsGraphYAxis: 'Costos promedio estimados por año',
  total: 'Total',
  trade_in_tooltip:
    'Es posible que sea necesario retirar un vehículo antiguo a gasolina para obtener ciertos incentivos.',
  trim: 'Recortar',
  type_tooltip:
    'Los vehículos totalmente eléctricos usan solo electricidad. Los híbridos enchufables pueden usar electricidad y gasolina.',
  Unfinished: 'Inconcluso',
  updateZipcode: 'Actualizar código postal',
  'vehicle.gasoline.metricPrice': 'PRECIO DE LA GASOLINA',
  'vehicle.gasoline.price': 'PRECIO DE LA GASOLINA',
  'vehicle.kilometers': 'kilómetros',
  'vehicle.kilometersCapital': 'kilómetros',
  'vehicle.kilometersPerThirtyFastCharge':
    'Kilómetros por cada 30 minutos de carga rápida',
  'vehicle.kilometersShort': 'kilómetros',
  'vehicle.milesCapital': 'Millas',
  'vehicle.milesCaptital': 'Millas',
  'vehicle.milesShort': 'mi',
  'vehicle.msrp': 'Precio de venta sugerido por el fabricante',
  'vehicle.status': 'Estado del vehículo',
  'vehicle.type.hatchback': 'Hatchback',
  'vehicle.type.minivan': 'Minivan',
  'vehicle.type.suv': 'SUV',
  'vehicles.none': 'No se encontraron vehículos',
  'incentives.noneFound':
    'Ningún incentivo coincide con tus filtros actuales. Intenta ampliar los filtros de vehículo o elegibilidad.',
  vehicleType:
    'Seleccione todos los tipos de carrocería de vehículo que le interesen.',
  viewSavings: ' VER AHORROS',
  Website: 'Sitio web',
  youAreEligible: 'Tú',
  zipCode: 'CÓDIGO POSTAL',
};

export default ESP_CUSTOM;
